import awsdk from 'awsdk';
import { Visit, VideoParticipant } from '../sdk/types';

/**
 * Function: useWebRTC
 * @desc Makes sure webRTC is supported and can be used.
 * @param visitOrParticipant
 */
export function useWebRTC(visitOrParticipant: Visit | VideoParticipant) {
  return awsdk.utils.WebRTCHelper.isWebRTCSupported() && visitOrParticipant.isUsingWebRTC;
}
